import DynamicElementsPopper from './DynamicElementsPopper';

export default DynamicElementsPopper;
